var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{style:({
    textAlign: 'center',
    padding: 0,
    width: _vm.thWidth,
    maxWidth: _vm.thWidth,
    verticalAlign: 'middle',
  })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }